export const maskPhone = (value: string) => {
    return value
        .replace(/\D/g, '') // Remove non-digits
        .replace(/^(\d{2})(\d)/g, '($1) $2') // mask DDD e.g. (11) 9
        .replace(/(\d)(\d{4})$/, '$1-$2') // mask last 4 chars
        .substring(0, 15); // limit length to (XX) XXXXX-XXXX
};

export const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
